import { render, staticRenderFns } from "./CardCarouselFinal.vue?vue&type=template&id=af3b7e80&"
import script from "./CardCarouselFinal.vue?vue&type=script&lang=js&"
export * from "./CardCarouselFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports